module.exports = __webpack_public_path__ + "./fonts/AchelanScript-X3Md9.ttf";